module.exports = __webpack_public_path__ + "img/icon-round-question.0a35d794.svg";